<template>
    <el-dialog v-dialogDrag title="附件上传" :visible.sync="dialogVisible" width="1000px"
               v-loading="dialoading"
               append-to-body
               :close-on-click-modal="false" @close="close">
        <div class="fileupload">
            <el-table
                    ref="table"
                    :data="dataList"
                    height="200"
                    style="width: 100%;overflow-y: scroll"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    border>
                <el-table-column
                        type="index"
                        width="50">
                </el-table-column>
                <el-table-column
                        prop="fileTrueName"
                        label="文件名">
                </el-table-column>
                <el-table-column
                        prop="fileSize"
                        label="文件大小"
                        width="200">
                    <template slot-scope="scope">
                        <div>{{getKb(scope.row.fileSize)}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="uploadBy"
                        label="上传人"
                        width="100">
                </el-table-column>
                <el-table-column
                        prop="uploadDate"
                        label="上传时间"
                        width="200">
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200">
                    <template slot-scope="scope">
                        <template>
                            <el-button @click="download(scope.row)" type="primary" icon="el-icon-download"
                                       size="medium"></el-button>
                            <el-button @click="delFile(scope.row)" type="danger" icon="el-icon-delete"
                                       size="medium"></el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <el-table
                    ref="uploadTable"
                    :data="fileList"
                    style="width: 100%;overflow-y: scroll;margin-top:10px;"
                    height="200px"
                    highlight-current-row
                    :header-cell-style="headerStyle"
                    :cell-style="cellStyle"
                    row-key="id"
                    border>
                <el-table-column
                        label="文件类型"
                        width="150">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items:center;justify-content:center">
                            <img width="30px" height="30px" :src="getImg(scope.row)">
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="name"
                        label="文件名">
                </el-table-column>
                <el-table-column
                        prop="size"
                        label="文件大小"
                        width="200">
                    <template slot-scope="scope">
                        <div>{{getKb(scope.row.size)}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="percentage"
                        label="状态"
                        width="200">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 'success'" type="success" effect="dark" size="small">
                            上传成功
                        </el-tag>
                        <el-tag v-else-if="scope.row.status == 'ready'" type="warning" effect="dark" size="small">
                            待上传
                        </el-tag>
                        <el-tag v-else-if="scope.row.status == 'fail'" type="danger" effect="dark" size="small">
                            上传失败
                        </el-tag>
                        <el-progress v-else :percentage="parsePercentage(scope.row.percentage)">
                        </el-progress>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed="right"
                        label="操作"
                        width="200">
                    <template slot-scope="scope">
                        <template>
                            <!--                                                <el-button @click="perview(scope.row)" type="primary"-->
                            <!--                                                           size="medium">重传-->
                            <!--                                                </el-button>-->
                            <el-button @click="del(scope.row)" type="danger" size="medium">删除</el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-upload
                        class="upload-demo"
                        :show-file-list="false"
                        ref="upload"
                        multiple
                        :action="action"
                        :on-change="onChange"
                        :on-error="onError"
                        :on-success="onSuccess"
                        :file-list="fileList"
                        with-credentials
                        :data="fileParam"
                        :auto-upload="false">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <el-button style="margin-left: 10px;" v-show="state === 'uploading'" size="small" type="danger"
                               @click="abort">
                        取消上传
                    </el-button>
                    <el-button style="margin-left: 10px;" v-show="state !== 'uploading'" size="small" type="success"
                               @click="submitUpload">
                        开始上传
                    </el-button>
                    <div slot="tip" class="el-upload__tip">文件大小不超过1GB</div>
                </el-upload>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "fileupload",
        props: ['fileParam', 'fileUrl', "fileListUrl", "delFileUrl","fileKey","fileKind"],
        data() {
            return {
                dialogVisible: true,
                dialoading: false,
                dataList: [],
                fileList: [],
                state: "ready",
                action: window.host.ProjectUrl + this.fileUrl,
            }
        },
        async created() {
            await this.getFileList();
        },
        methods: {
            async getFileList() {
                this.dialoading = true;
                let param = {
                    url: this.fileListUrl,
                    param: {
                        ...this.fileParam
                    }
                }
                const data = await this.$store.dispatch('pubMethod', param)
                this.dialoading = false;
                if (data.infoCode === '0') {
                    this.dataList = data.data.data;
                }
            },
            submitUpload() {
                this.fileList.map(item => {
                    if (item.status === "ready") {
                        this.state = "uploading";
                    }
                })
                this.$refs.upload.submit();
            },
            onChange(file, fileList) {
                this.fileList = fileList;
                this.$nextTick(() => {
                    this.$refs.uploadTable.doLayout(); // 解决表格错位
                });
            },
            onError(err, file, fileList) {
                console.log(err, file, fileList)
            },
            onSuccess(response, file, fileList) {
                this.state = "ready";
                fileList.map(item => {
                    if (item.status === "uploading") {
                        this.state = "uploading"
                    }
                })
                this.getFileList();
            },
            headerStyle() {
                return "text-align:center;height:45px;line-hight:45px;padding: 1px 0;background-color:#f2f2f2;border-left:1px solid #e5e6e8;border-top:1px solid #e5e6e8;border-bottom:1px solid #e5e6e8"
            },
            cellStyle() {
                return "text-align:center"
            },
            close() {
                this.$emit('closeDialog')
            },
            abort() {
                this.$refs.upload.abort();
                this.fileList.map(item => {
                    if (item.status === "uploading") {
                        item.status = "ready"
                    }
                })
                this.state = "ready";
            },
            download(row) {
                window.open(window.host.ProjectUrl + "/" + row.fileUrl + "/" + row.fileName, '_blank')
            },
            delFile(row) {
                this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.dialoading = true;
                    let param = {
                        url: this.delFileUrl,
                        param: {
                            // productAnnexId: row.productAnnexId,
                        }
                    }
                    param.param[this.fileKey] = row[this.fileKey];
                    const data = await this.$store.dispatch('pubMethod', param)
                    if (data.infoCode === "0") {
                        this.$message({message: '删除成功', type: 'success'});
                        await this.getFileList();
                    }
                    this.dialoading = false;
                })
            },
            del(row) {
                let index = this.fileList.findIndex(item => {
                    return row.uid === item.uid
                })
                this.fileList.splice(index, 1);
            },
            parsePercentage(val) {
                return parseInt(val, 10);
            },
            getKb(val) {
                if (val)
                    return (val / 1024).toFixed(2) + "KB"
            },
            getImg(row) {
                let type = this.getFileType(row.name);
                const url = require("@/assets/fileicon/" + type + ".png");
                return url;
            },
            getFileType(fileName) {
                // 后缀获取
                let suffix = '';
                // 获取类型结果
                let result = '';
                try {
                    const flieArr = fileName.split('.');
                    suffix = flieArr[flieArr.length - 1];
                } catch (err) {
                    suffix = '';
                }
                // fileName无后缀返回 false
                if (!suffix) {
                    return false;
                }
                suffix = suffix.toLocaleLowerCase();
                // 图片格式
                const imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
                // 进行图片匹配
                result = imglist.find(item => item === suffix);
                if (result) {
                    return 'image';
                }
                // 匹配txt
                const txtlist = ['txt'];
                result = txtlist.find(item => item === suffix);
                if (result) {
                    return 'txt';
                }
                // 匹配 excel
                const excelist = ['xls', 'xlsx'];
                result = excelist.find(item => item === suffix);
                if (result) {
                    return 'xls';
                }
                // 匹配 word
                const wordlist = ['doc', 'docx'];
                result = wordlist.find(item => item === suffix);
                if (result) {
                    return 'doc';
                }
                // 匹配 pdf
                const pdflist = ['pdf'];
                result = pdflist.find(item => item === suffix);
                if (result) {
                    return 'pdf';
                }
                // 匹配 ppt
                const pptlist = ['ppt', 'pptx'];
                result = pptlist.find(item => item === suffix);
                if (result) {
                    return 'ppt';
                }
                // 匹配 视频
                const videolist = ['mp4', 'm2v', 'mkv', 'rmvb', 'wmv', 'avi', 'flv', 'mov', 'm4v'];
                result = videolist.find(item => item === suffix);
                if (result) {
                    return 'video';
                }
                // 匹配 音频
                const radiolist = ['mp3', 'wav', 'wmv'];
                result = radiolist.find(item => item === suffix);
                if (result) {
                    return 'mp3';
                }
                // 匹配 音频
                const ziplist = ['zip', 'rar', 'arj'];
                result = ziplist.find(item => item === suffix);
                if (result) {
                    return 'zip';
                }
                // 其他 文件类型
                return 'other';
            }
        },
    }
</script>

<style scoped>
    .fileupload /deep/ .el-table .el-table__cell {
        padding: 5px 0;
    }

    .fileupload /deep/ .el-table__body tr.current-row > td.el-table__cell {
        background-color: #66c4f6;
    }
</style>
